var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lang-group"},[_c('h4',{style:({ color: _vm.myColors.main })},[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.langData.languages),function(item,index){return _c('Language',{key:index,attrs:{"exp":item.experience,"name":item.name}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }